import React from 'react';
import Sidebar from './Sidebar';
import { Col, Layout, Row, Typography } from 'antd';
import NotificationAPIComponent from './NotificationAPIComponent';
import { useLocation } from 'react-router-dom';
import Title from 'antd/es/typography/Title';
import { AccountSummary } from '../App';
const { Content } = Layout;

const generatePageTitle = (
  path: string
): {
  title: string;
  subTitle?: string;
} => {
  const pathParts = path.split('/').map((part) => part.trim().toLowerCase());
  switch (pathParts[2]) {
    case 'notifications':
      return {
        title: 'Notifications',
        subTitle: pathParts[3]
      };
    case 'newnotification':
      return {
        title: 'New Notification',
        subTitle: ''
      };
    case 'environments':
      return {
        title: 'Environments',
        subTitle: ''
      };
    case 'settings':
      return {
        title: 'Settings',
        subTitle: ''
      };
    case 'plan':
      return {
        title: 'Plan Usage',
        subTitle: 'Overview of your plan usage and limits'
      };
    case 'insights':
      return {
        title: 'Insights',
        subTitle: 'Reports on your notifications and more'
      };
    case 'logs':
      return {
        title: 'Logs',
        subTitle: 'Complete Log of your requests'
      };
    case 'onboarding':
      return {
        title: 'Welcome  👋'
      };
    case 'inapp':
      return {
        title: 'In-App Widget',
        subTitle: 'Customize and integrate your in-app widget'
      };
    case 'users':
      return {
        title: 'Users',
        subTitle: 'Your end-users and notification recipients'
      };
    default:
    //
  }

  return {
    title: ' '
  };
};

interface Props {
  children?: React.ReactNode;
  sliderItem: string;
  envId: string;
  setEnvId: (envId: string) => void;
  admin: boolean;
  accountSummary: AccountSummary;
}

const PageLayout = ({
  children,
  sliderItem,
  envId,
  setEnvId,
  admin,
  accountSummary
}: Props): JSX.Element => {
  const location = useLocation();
  const { title, subTitle } = generatePageTitle(location.pathname);
  return (
    <>
      <Sidebar
        item={sliderItem}
        envId={envId}
        setEnvId={setEnvId}
        admin={admin}
        accountSummary={accountSummary}
      />
      <Content style={{ minHeight: '100vh' }}>
        <Row
          justify="space-between"
          style={{ background: '#fff', padding: '20px', height: '72px' }}
        >
          <Col>
            <Title level={4} style={{ margin: 0, display: 'inline-block' }}>
              {title}
            </Title>
            <Typography.Text
              type="secondary"
              style={{ display: 'inline-block', margin: '0 0 0 16px' }}
            >
              {subTitle}
            </Typography.Text>
          </Col>
          <Col>
            {accountSummary.hasNotification && accountSummary.hasUsers && (
              <NotificationAPIComponent />
            )}
          </Col>
        </Row>
        {children}
      </Content>
    </>
  );
};
export default PageLayout;
